import { render, staticRenderFns } from "./OeGenDetail.vue?vue&type=template&id=55467eac&scoped=true&"
import script from "./OeGenDetail.vue?vue&type=script&lang=js&"
export * from "./OeGenDetail.vue?vue&type=script&lang=js&"
import style0 from "./OeGenDetail.vue?vue&type=style&index=0&id=55467eac&prod&scoped=true&lang=css&"
import style1 from "./OeGenDetail.vue?vue&type=style&index=1&id=55467eac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55467eac",
  null
  
)

export default component.exports